var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-login"},[_c('FormHeader',{attrs:{"headerTitle":_vm.headerTitle}}),_c('div',{staticClass:"form-body-wrap"},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }